import React from 'react';
import { NextPage } from 'next';

import { Container, Row, Col } from 'reactstrap';
import { Button } from 'components/common/Button';
import { ContentSection } from 'components/common/ContentSection';
import { Layout } from 'components/common/Layout';
import { MaxWidthImage } from 'components/common/MaxWidthImage';
import { MetaTags } from 'components/meta/MetaTags';
import { TitleHeader } from 'components/header/TitleHeader';

interface Props {
    pathName: string;
}
const Route: NextPage<Props> = ({ pathName }) => {
    return (
        <Layout pathName={pathName}>
            <MetaTags
                title="Werken bij Developers.nl | Routebeschrijving"
                image="/favicons/logo_180.png"
                description="Enthousiast geworden als developer? Kom snel in contact met Developers.nl!"
                keywords="developer, developers, frontend, php, python, java, learn, code, share"
            />
            <TitleHeader title="Routebeschrijving" />
            <ContentSection>
                <h2>Met de auto</h2>
                <h5>A16 vanuit Den Haag/ Rotterdam / Utrecht</h5>
                <p>
                    Houd recht aan op de van Brienenoordbrug. Na de brug neem je afslag 24 en volg je de borden
                    Feijenoord/IJsselmonde/Havens. Houd links aan bij de splitsing om door te rijden in de richting van
                    de Kuip. Vervolgens blijf je rechts aanhouden. Bij de stoplichten sla je af naar rechts en direct
                    naar links de Stadionweg op. Hier blijf je rechtdoor rijden tot net na de Sligro aan je rechterhand.
                    Hier zie je een oud gebouw. Sla ‘onder’ dit gebouw rechtsaf onder een poort door.
                </p>
                <h5>A16 vanuit Breda</h5>
                <p>
                    Neem afslag 24 Rotterdam Feijenoord Beverwaard. Houd links aan richting de Kuip. Houd vervolgens
                    rechts aan. Bij de stoplichten sla je af naar rechts en direct naar links de Stadionweg op. Hier
                    blijf je rechtdoor rijden tot net na de Sligro aan je rechterhand. Hier zie je een oud gebouw. Sla
                    ‘onder’ dit gebouw rechtsaf onder een poort door.
                </p>
                <a href="https://goo.gl/maps/ku1ffWcuoNyGRJsR9" rel="noopener noreferrer" target="_blank">
                    <Button more={true}>Route via Google Maps</Button>
                </a>
            </ContentSection>
            <ContentSection>
                <div>
                    <h5>Gratis parkeren!</h5>
                    Je bevindt je nu op de parkeerplaats van ons pand. Je kunt hier gratis parkeren. Nadat je geparkeerd
                    hebt, loop je terug naar de poort en sla je linksaf. Hier vind je de entree van het gebouw.
                </div>
                <Container>
                    <Row>
                        <Col sm={12} lg={{ size: 6, offset: 3 }}>
                            <MaxWidthImage src="https://picsum.photos/id/444/450/300"></MaxWidthImage>
                        </Col>
                    </Row>
                </Container>
            </ContentSection>
            <ContentSection>
                <h2>Openbaar vervoer</h2>
                <p>
                    Mocht je met het OV komen, wat erg praktisch is; tramhalte Stadion Feyenoord zit op 1 minuut
                    loopafstand (tram 12 en 23).
                </p>
            </ContentSection>
        </Layout>
    );
};

Route.getInitialProps = (ctx): Props => {
    return { pathName: ctx.pathname };
};

export default Route;
